export const environment = {
   production: false,
   testMode: true,
   connectFunctionsEmulator: false,
   skipCache: false,
};
